import type { Event } from '@sentry/browser';
import type { IHttpError } from '@wix/http-client';
import { WixHttpErrorDetails } from '../types';
import { defaults } from './general-utils';

const extractWixHttpErrorDetailsRec = (
  error?: Error | IHttpError,
): WixHttpErrorDetails => {
  if (!(error instanceof Error)) {
    return {};
  }

  const res = extractWixHttpErrorDetailsRec(error.cause as any);
  const httpClientError = error as IHttpError;

  return defaults<WixHttpErrorDetails>(res, {
    isWixHttpError: httpClientError.isWixHttpError,
    requestId:
      httpClientError.response?.headers?.['x-wix-request-id'] ??
      httpClientError.requestId,
  });
};

export const extractWixHttpErrorDetails = (
  error?: Error | IHttpError,
): WixHttpErrorDetails =>
  defaults<WixHttpErrorDetails>(extractWixHttpErrorDetailsRec(error), {
    isWixHttpError: false,
    requestId: '',
  });

export const normalizeError = (event: Event, error?: unknown): Error => {
  if (!(error instanceof Error)) {
    const err = new Error(typeof error === 'string' ? error : event.message);

    delete err.stack;

    return err;
  }

  return error;
};

export const createUndedupableError = (error: Error) => {
  const { message, stack, cause } = error;

  const res = Object.assign(Object.create(Object.getPrototypeOf(error)), {
    name: `${Date.now() + Math.random()}`,
    message,
    stack,
    cause,
  });

  return res;
};
